import { groupBy, sortBy, startCase } from "lodash";
import React from "react";
import { Updater } from "use-immer";

import {
  IgButton,
  IgDivider,
  IgPaper,
  IgTypography,
} from "@intelligems/ig-theme";
import { ConfigurationDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import { usePatchConfigurations } from "../../../../../api/configurations/patch-configurations";
import { useGetOrg } from "../../../../../api/organizations/get-organization";
import { getNewModifiedConfigs, onConfigChange } from "../../../Utils/Utils";

import { ConfigurationInput } from "./index";

interface AdvancedConfigurationsProps {
  settingsState: ConfigurationDto[];
  setSettingsState: Updater<ConfigurationDto[]>;
}

const titles = {
  GENERAL: "General Settings",
  PLUGIN_CONFIG: "Plugin Configurations",
  WEB_UI_SCOPE: "Web App Configurations",
  UI_CONFIG: "UI Configurations",
  ANALYTICS: "Analytics Configurations",
  FEATURE_TOGGLE: "Feature Toggles",
};

export const AdvancedConfigurations = ({
  settingsState,
  setSettingsState,
}: AdvancedConfigurationsProps) => {
  const mutateConfigurations = usePatchConfigurations();
  const organization = useGetOrg();

  return (
    <Grid container direction={"column"} rowSpacing={2}>
      {sortBy(
        Object.entries(groupBy(settingsState, (_) => _.topic)),
        (_) => _[0]
      ).map(([key, settings], index) => {
        return (
          <Grid item key={`${key}-${index}`}>
            <IgPaper key={key}>
              <Grid container direction={"column"} rowSpacing={2}>
                <Grid item>
                  <IgTypography variant={"h6"}>{titles[key]}</IgTypography>
                </Grid>
                {Object.entries(groupBy(settings, (_) => _.type)).map(
                  ([key, settings], groupIndex) => {
                    return (
                      <Grid
                        container
                        direction={"column"}
                        rowSpacing={2}
                        key={`${key}-${groupIndex}`}
                      >
                        <Grid item>
                          <Grid item textAlign={"end"}>
                            <IgTypography
                              sx={{ fontWeight: 600 }}
                            >{`${startCase(key)} Fields`}</IgTypography>
                          </Grid>
                          <Grid container direction={"column"} rowSpacing={1}>
                            {sortBy(settings, "key").map((setting) => {
                              return (
                                <Grid item key={setting.key}>
                                  <ConfigurationInput
                                    config={setting}
                                    onChange={(newValue: any) =>
                                      onConfigChange(
                                        setting.key,
                                        newValue,
                                        setSettingsState
                                      )
                                    }
                                  />
                                </Grid>
                              );
                            })}
                          </Grid>
                        </Grid>
                        <Grid item>
                          <IgDivider spacing={"m"} />
                        </Grid>
                      </Grid>
                    );
                  }
                )}
                <Grid item xs textAlign={"end"}>
                  <IgButton
                    loading={mutateConfigurations.isPending}
                    style={{ marginTop: 5 }}
                    size="medium"
                    variant={"contained"}
                    onClick={() =>
                      mutateConfigurations.mutate(
                        getNewModifiedConfigs(
                          settingsState,
                          organization.data.org.configurations
                        ) || []
                      )
                    }
                  >
                    Save Configurations
                  </IgButton>
                </Grid>
              </Grid>
            </IgPaper>
          </Grid>
        );
      })}
    </Grid>
  );
};
